export const LOAD_TRAFFIC = 'miniWidget/LOAD_TRAFFIC';
export const LOAD_WEATHER = 'miniWidget/LOAD_WEATHER';
export const MINI_WIDGET_GET = 'miniWidget/MINI_WIDGET_GET';
